export default {
  SET_TOKEN(state, payload) {
    state.token = payload;
  },

  SET_LOADING(state, payload) {
    state.loading = payload;
  },

  SET_MOBILE(state, payload) {
    state.mobile = Boolean(payload);
  },

  SET_SHOW_SURVEY_COMMISSIONS(state, payload) {
    state.show_survey_commissions = payload;
  },

  SET_STATUSES(state, payload) {
    state.statuses = payload;
  },

  SET_SUPPLIERS(state, payload) {
    state.suppliers = payload;
  },
};
